import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/LandingPage';
import { SupportPage } from './pages/SupportPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { SupportPolicyPage } from './pages/SupportPolicyPage';
import { TermsPage, LegalTermsPage, PrivacyPage, CookiePolicyPage, PrivacyChoicesPage, CodeOfConductPage, RewardsRulesPage } from './pages/LegalPages';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<LandingPage data-id="element-5" />} data-id="element-4" />
          <Route path="support" element={<SupportPage data-id="element-7" />} data-id="element-6" />
          <Route path="support-policy" element={<SupportPolicyPage data-id="element-9" />} data-id="element-8" />
          <Route path="faq" element={<FAQPage data-id="element-11" />} data-id="element-10" />
          <Route path="contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
          <Route path="about" element={<AboutPage data-id="element-15" />} data-id="element-14" />

          {/* Legal Pages */}
          <Route path="terms" element={<TermsPage data-id="element-17" />} data-id="element-16" />
          <Route path="legal-terms" element={<LegalTermsPage data-id="element-19" />} data-id="element-18" />
          <Route path="privacy" element={<PrivacyPage data-id="element-21" />} data-id="element-20" />
          <Route path="cookies" element={<CookiePolicyPage data-id="element-23" />} data-id="element-22" />
          <Route path="privacy-choices" element={<PrivacyChoicesPage data-id="element-25" />} data-id="element-24" />
          <Route path="code-of-conduct" element={<CodeOfConductPage data-id="element-27" />} data-id="element-26" />
          <Route path="rewards-rules" element={<RewardsRulesPage data-id="element-29" />} data-id="element-28" />
        </Route>
      </Routes>
    </Router>;
}